import api from '../module_user/api/api';
const baseUrl = process.env.VUE_APP_API_URL;

export default {
    
    async createNewAssessment(data) {
        let response = await api.post(baseUrl + '/fsb-assessment/add', data);
        return response.data;
    },

    async listRecommendedAssessments(data) {
        const params = new URLSearchParams(data).toString();
        let response = await api.get(`${baseUrl}/fsb-assessment/recommended/list?${params}`);
        return response.data;
    },

    async listAssessments(data) {
        const params = new URLSearchParams(data).toString();
        let response = await api.get(`${baseUrl}/fsb-assessment/list?${params}`);
        return response.data;
    },

    async viewAnalysisReport(id) {
        let response = await api.get(baseUrl + `/fsb-assessment/report/${id}`);
        return response.data;
    },

    async updateReport(id,data) {
        let response = await api.put(baseUrl + `/fsb-assessment/report/${id}`,data);
        return response.data;
    },
    
    async getAssessmentDetails(id) {
        let response = await api.get(baseUrl + `/fsb-assessment/details/${id}`);
        return response.data;
    },

    async getRecommendedVideos(id) {
        let response = await api.get(baseUrl + `/fsb-assessment/selected/${id}`);
        return response.data;
    },

    async getNextAssessmentVideoData(id) {
        let response = await api.get(baseUrl + `/fsb-assessment/video/${id}`);
        return response.data;
    },

    async updateAssessmentVideoSession(data) {
        let response = await api.put(baseUrl + `/fsb-assessment/set-session`,data);
        return response.data;
    },

    async deleteAssessment(id) {
        let response = await api.delete(baseUrl + `/fsb-assessment/remove/${id}`);
        return response.data;
    },

    async sendReportMail(id,data) {
        let response = await api.post(baseUrl + `/fsb-assessment/report/send-mail/${id}`,data);
        return response.data;
    },
}
